<template>
    <div class="staff-debug">
        <b-button 
            v-if="userIsStaff" 
            size="sm" 
            variant="bare-primary"
            class="button-text text-secondary font-size-60" 
            @click="toggleDebug"
        >
            {{ buttonText }}
        </b-button>
        <div v-if="userIsStaff && debugShowing" class="p-3 border">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { currentUserInfoMixin } from '@/js/custom-vue-mixins';
/* 
HOW THIS WORKS:
- this will ONLY show if current USER is staff user (based on currentUserInfo)
- just shows a small button that will show/hide a div that is the debug area
- pass things to the default slot of the component, that's what shows up in the debug area
- if current user is NOT staff, the component is still rendered, but nothing is shown
*/

export default {
    name: 'StaffDebug',
    components: {},
    mixins: [currentUserInfoMixin],
    props: {
        buttonText: {
            type: String,
            default: 'Debug',
        },
    },
    data() {
        return {
            debugShowing: false,
        }
    },
    computed: {
        userIsStaff() {
            return this.$currentUserInfo?.user_is_staff;
        },
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        toggleDebug() {
            this.debugShowing = !this.debugShowing;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>